import { getRequest, CreateRequestBranch, updateRequestBranch, activateRequest } from '../../admin/request';
import { RequestQueryParams, Create_Update_BranchPayload } from '../../../../contract/dtos';

export const requestQueries = {
  queries: {
    // Query for fetching requests list
    list: (params?: RequestQueryParams) => ({
      queryKey: ['requests', params],
      queryFn: async () => getRequest(params),
    }),
   
  },
  mutations: {
    // Mutation for creating a branch for a request
    createBranch: (requestId: number, payload: Create_Update_BranchPayload) => ({
      mutationKey: ['request-create-branch', requestId],
      mutationFn: async () => CreateRequestBranch(requestId, payload),
    }),
    // Mutation for updating a specific branch for a request
    updateBranch: (requestId: number, branchId: number, payload: Create_Update_BranchPayload) => ({
      mutationKey: ['request-update-branch', requestId, branchId],
      mutationFn: async () => updateRequestBranch(requestId, branchId, payload),
    }),
    // Mutation for activating a request
    activate: (requestId: number) => ({
      mutationKey: ['request-activate', requestId],
      mutationFn: async () => activateRequest(requestId),
    }),
  }
};
